class TSMainProduct extends HTMLElement {
  constructor() {
    super();
    this.productVariants = JSON.parse(this.querySelector("#TSProductVariants").textContent);
    this.quantityElement = this.querySelector("#TSMainQuantity");
    this.mainGallery = this.querySelector("#TSMainGallery");
    this.sideGallery = this.querySelector("#TSSideGallery");
    this.productForm = this.querySelector("#TSProductForm");
    this.productPrice = this.querySelector("#TSMainPrice");
    this.productOptions = this.querySelector("#TSProductOptions");
    this.productSubmit = this.querySelector(".koala-deal__bundle-action__button, #TSProductSubmit");
    this.bundleSubmit = this.querySelector(".koala-deal__bundle-action__button");
    this.productMessage = this.querySelector("#TSFormMessage");
    this.backInStock = this.querySelector("#TSBackInStock");
    this.mainGallerySlider = false;
    this.isLoading = false;
    this.slideMaxLength = this.sideGallery.querySelectorAll('[data-media]').length;
    this.galleryCurrentSlide = 1;
    this.mainGallerySlide = 1;
    this.stickyAdd = this.querySelector("#TSStickyAdd");

    this.initClickEvent();
    this.initSubmitEvent();
    this.initScrollEvent();
    this.initMouseoverEvent();
    this.initSlider();

    this.querySelectorAll('[data-trigger="disclosure"].open').forEach(disclosure => {
      disclosure.nextElementSibling.style.maxHeight = disclosure.nextElementSibling.scrollHeight + "px";
    })

    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-option-block]")) {
        this.querySelectorAll("[data-option-block] [data-values]").forEach(list => list.classList.remove("open"));
      }
    })

    if (this.querySelector("#TSMainProductTrending")) {
      setInterval(this.updateTrending.bind(this), 10000);
    }

    if (this.stickyAdd && this.productSubmit) { 
      this.toggleSticky();
      window.addEventListener("scroll", this.toggleSticky.bind(this));
    }
  }

  initSlider() {
    this.mainGallerySlider = new Flickity(this.mainGallery, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      draggable: true
    });

    this.mainGallerySlider.on('change', (index) => {
      this.changeSlide(this.sideGallery.querySelector(`[data-slide="${index}"]`));
    });
  }

  variantChange() {
    this.addLoading();

    const searchParams = new URLSearchParams(window.location.search);
    let selectedValuesLabel = '';

    [1, 2, 3].forEach(option => {
      if (this.querySelector(`[data-option-block="${option}"]`)) {
        selectedValuesLabel += ' / ' + this.querySelector(`[data-option-block="${option}"] [data-current-value]`).dataset.currentValue;
      }
    });

    this.productVariants.forEach(variant => {
      if (variant.title === selectedValuesLabel.slice(3)) {
        this.variant = variant;
      }
    })

    if (this.productForm) {
      this.productForm.querySelector("[name='id']").value = this.variant.id;
    }

    searchParams.set('variant', this.variant.id);
    const newProductUrl = window.location.origin + window.location.pathname + `?${searchParams.toString()}`;
    window.history.replaceState({}, '', newProductUrl);

    fetch(newProductUrl)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");
      const selectors = ["#TSMainPrice", "#TSProductOptions", "#TSProductSubmit", "#TSMainGallery", "#TSSideGallery", "#TSStickyAdd"];

      if (this.mainGallerySlider.destroy) {
        this.mainGallerySlider.destroy();
        this.mainGallerySlider = false;
      }

      selectors.forEach(selector => {
        if (this.querySelector(selector) && html.querySelector(selector)) {
          this.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        }
      })

      if (this.querySelector(".ts-product__button-wrapper")) {
        const isAvailable = html.querySelector(".ts-product__button-wrapper").classList.contains("is-available");
        this.querySelector(".ts-product__button-wrapper").classList.toggle("is-available", isAvailable);

        this.galleryCurrentSlide = 1;
        this.mainGallerySlide = 1;
        this.updateSideGallery();
        this.initSlider();
        
        if (isAvailable) {
          this.productSubmit.removeAttribute("data-trigger");
        } else {
          this.productSubmit.setAttribute("data-trigger", "back-in-stock");
        }

        if (window.syncCellBisAvailability) window.syncCellBisAvailability();
      }
      this.removeLoading();
    }).catch(error => {
      console.error(error);
      this.removeLoading();
    })
  }

  addToCart() {
    this.addLoading();

    const cartData = {
      items: [
        {
          id: parseInt(this.productForm.querySelector("[name='id']").value),
          quantity: parseInt(this.productForm.querySelector("[name='quantity']").value)
        }
      ]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        let error = new Error(response.description);
        throw error;
      } else {
        if (this.productMessage) {
          this.productMessage.innerHTML = "";
        }
        this.removeLoading();

        fetch(`${window.theme.routes.cart}.js`)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          return response.json();
        })
        .then(data => {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: {
              cart: data
            },
            bubbles: true
          }));

          document.querySelector('[data-drawer-toggle="drawer-cart"]')?.dispatchEvent(new Event("click"));
        })
        .catch(e => {
          console.error(e);
        });
      }
    }).catch((error) => {
      if (this.productMessage) {
        this.productMessage.innerHTML = error;
        setTimeout(() => {this.productMessage.innerHTML = ''}, 5000);
      }
      this.removeLoading();
      console.error(error);
    });
  }

  changeSlide(target) {
    const allSlides = this.mainGallery.querySelectorAll('[data-media]');
    const mainGalleryControls = this.mainGallery.nextElementSibling.querySelectorAll("[data-prev], [data-next]");
    
    this.mainGallerySlider.select(parseInt(target.dataset.slide));
    this.mainGallerySlide = parseInt(target.dataset.slide) + 1;

    this.sideGallery.querySelector(".selected").classList.remove("selected");
    target.classList.add("selected");

    mainGalleryControls[0].classList.toggle("disabled", this.mainGallerySlide == 1);
    mainGalleryControls[1].classList.toggle("disabled", this.mainGallerySlide == allSlides.length);
  }

  updateSideGallery() {
    const blocks = this.sideGallery.querySelectorAll('[data-media]');
    const controls = this.sideGallery.nextElementSibling.querySelectorAll("[data-prev], [data-next]");

    let scrollLeft = this.sideGallery.scrollLeft;;
    let clientWidth = this.sideGallery.clientWidth;
    let blockWidth = blocks[0].offsetWidth;
    let gap = 12;

    if (window.innerWidth > 650) {
      scrollLeft = this.sideGallery.scrollTop;
      clientWidth = this.sideGallery.clientHeight;
      blockWidth = blocks[0].offsetHeight;
    } else {
      const scrollWidth = this.sideGallery.scrollWidth;
      const scrollLeft = this.sideGallery.scrollLeft;
      const scrollbarThumb = this.querySelector(".ts-product__scroll-thumb");
      const thumbPosition = (scrollLeft / (scrollWidth - clientWidth)) * 100;
      const thumbWidth = (clientWidth / scrollWidth) * 100;

      scrollbarThumb.style.left = `${thumbPosition}%`;
      scrollbarThumb.style.width = `${thumbWidth}%`;
      scrollbarThumb.style.transform = `translateX(-${thumbPosition}%)`;
    }

    this.slideMaxLength = Math.max(1, blocks.length - (Math.floor(clientWidth / blockWidth) - 1));
    this.galleryCurrentSlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;

    controls[0].classList.toggle("disabled", this.galleryCurrentSlide == 1);
    controls[1].classList.toggle("disabled", this.galleryCurrentSlide == this.slideMaxLength);

    this.sideGallery.classList.toggle("ts-scroll-start", this.galleryCurrentSlide == 1);
    this.sideGallery.classList.toggle("ts-scroll-end", this.galleryCurrentSlide == this.slideMaxLength);
  }

  updateMainGallery() {
    const allSlides = this.mainGallery.querySelectorAll('[data-media]');
    const currentSlide = this.mainGallery.querySelector('.active[data-media]');
    const mainGalleryControls = this.mainGallery.nextElementSibling.querySelectorAll("[data-prev], [data-next]");
    const newSlide = this.mainGallery.querySelector(`[data-index="${this.mainGallerySlide - 1}"]`);

    currentSlide.classList.remove('active');
    newSlide.classList.add("active");

    this.sideGallery.querySelector(".selected").classList.remove("selected");
    this.sideGallery.querySelector(`[data-media="${newSlide.dataset.media}"]`).classList.add("selected");

    mainGalleryControls[0].classList.toggle("disabled", this.mainGallerySlide == 1);
    mainGalleryControls[1].classList.toggle("disabled", this.mainGallerySlide == allSlides.length);
  }

  initScrollEvent() {
    this.updateSideGallery();
    this.sideGallery.addEventListener("scroll", () => {
      this.updateSideGallery();
    });
  }

  initClickEvent() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        const currentQuantity = parseInt(this.quantityElement?.querySelector("input").value);
        switch (e.target.dataset.trigger) {
          case "options":
            const optionValuesTab = e.target.nextElementSibling;
            optionValuesTab.classList.toggle("open");
            break;
          case "quantity-increase":
            if (currentQuantity < 99) {
              this.quantityElement.querySelector("input").value = currentQuantity + 1;
              this.quantityElement.querySelectorAll("[data-trigger]")[0].classList.toggle("disabled", (currentQuantity + 1) === 1);
              this.quantityElement.querySelectorAll("[data-trigger]")[1].classList.toggle("disabled", (currentQuantity + 1) === 99);
            }
            break;
          case "quantity-decrease":
            if (currentQuantity > 1) {
              this.quantityElement.querySelector("input").value = currentQuantity - 1;
              this.quantityElement.querySelectorAll("[data-trigger]")[0].classList.toggle("disabled", (currentQuantity - 1) === 1);
              this.quantityElement.querySelectorAll("[data-trigger]")[1].classList.toggle("disabled", (currentQuantity - 1) === 99);
            }
            break;
          case "slide":
            this.changeSlide(e.target);
            break;
          case "swatch":
            const currentColorOptionElement = this.querySelector(`[data-option="${e.target.dataset.option}"] [data-current-value]`)
            currentColorOptionElement.setAttribute("data-current-value", e.target.dataset.value);
            this.variantChange();
            break;
          case "value-change":

            const valuesSelectElement = e.target.closest("[data-values]");
            const currentOptionElement = this.querySelector(`[data-option="${e.target.dataset.option}"] [data-current-value]`);
            const index = e.target.closest("[data-option-block]").dataset.optionBlock;

            valuesSelectElement.classList.remove("open");
            currentOptionElement.setAttribute("data-current-value", e.target.dataset.value);

            if (this.stickyAdd) {
              this.querySelectorAll(`[data-option-block="${index}"]`).forEach(optionBlock => {
                optionBlock.setAttribute("data-current-value", e.target.dataset.value);
              })
            }

            this.variantChange();
            break;
          case "main-change":
            const allSlides = this.mainGallery.querySelectorAll('[data-media]');

            if (e.target.hasAttribute("data-prev") && this.mainGallerySlide > 1) {
              this.mainGallerySlide -= 1;
            } else if (e.target.hasAttribute("data-next") && this.mainGallerySlide < allSlides.length) {
              this.mainGallerySlide += 1;
            }

            this.changeSlide(this.sideGallery.querySelector(`[data-slide="${this.mainGallerySlide - 1}"]`));
            break;  
          case "nav-change":
            if (e.target.hasAttribute("data-prev") && this.galleryCurrentSlide > 1) {
              this.galleryCurrentSlide -= 1;
            } else if (e.target.hasAttribute("data-next") && this.galleryCurrentSlide < this.slideMaxLength) {
              this.galleryCurrentSlide += 1;
            }

            if (window.innerWidth > 650) {
              this.sideGallery.scrollTo({
                top: this.sideGallery.querySelector(`li:nth-child(${this.galleryCurrentSlide})`).offsetTop,
                behavior: 'smooth'
              });
            } else {
              this.sideGallery.scrollTo({
                left: this.sideGallery.querySelector(`li:nth-child(${this.galleryCurrentSlide})`).offsetLeft,
                behavior: 'smooth'
              });
            }

            break;  
          case "disclosure":
            const disclosureContent = e.target.nextElementSibling;
            e.target.classList.toggle("open");
            disclosureContent.style.maxHeight = e.target.classList.contains("open") ? disclosureContent.scrollHeight + "px" : null;
            break;  
          case "sticky-add":
            if (this.bundleSubmit) {
              this.bundleSubmit.click();
            } else {
              this.addToCart();
            }
            break;
          case "back-in-stock":
            e.preventDefault();
            this.backInStock.classList.add("open");
            break;  
          case "bis-close":
            this.backInStock.classList.remove("open");
            break;  
        }
      }
    })
  }

  initSubmitEvent() {
    this.addEventListener("submit", (e) => {
      e.preventDefault();
      this.addToCart();
    })
  }

  initMouseoverEvent() {
    this.addEventListener("mouseover", (e) => {
      if (e.target.dataset.trigger == "slide") {
        this.changeSlide(e.target);
      }
    })
    
    this.querySelectorAll('[data-trigger="slide"]').forEach(slide => {
      slide.addEventListener("mouseover", () => {
        this.changeSlide(slide);
      })
    }) 
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  toggleSticky() {
    const heightToTop = this.productSubmit.offsetTop + this.productSubmit.scrollHeight;
    const footer = document.querySelector('.shopify-section-group-group-footer');
    const footerTop = footer?.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;
    
    const isFooterVisible = footerTop && footerTop <= windowHeight;
    const shouldShowSticky = !this.isInViewport(this.productSubmit) && 
                            window.scrollY > heightToTop && 
                            !isFooterVisible;
    
    this.stickyAdd.classList.toggle("is-show", shouldShowSticky);
}

  removeLoading() {
    this.isLoading = false;
    this.classList.remove("loading");
  }

  addLoading() {
    this.isLoading = true;
    this.classList.add("loading");
  }
}

customElements.define("ts-product", TSMainProduct);



 document.addEventListener('DOMContentLoaded', function() {
    const trigger = document.querySelector('.ts-product__raiting');
    const target = document.querySelector('.jdgm-rev-widg');

    if (trigger && target) {
      trigger.addEventListener('click', function() {
        target.scrollIntoView({ behavior: 'smooth' });
      });
    }
  });